import React, { useState } from "react";
import { Box, TableCell, TableRow } from "@mui/material";
import { DotLegalButton, DotLegalOverflowMenu, DotLegalPageHeader, DotLegalTable, ITableHeader } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../localization/useTranslation";
import { useEmailCustomization } from "./EmailCustomization.hooks.ts";
import { IdNamePair } from "../customLists/customListView/CustomListView.types.ts";
import CustomizeEmailTextDialog from "./customizeEmailTextDialog/CustomizeEmailTextDialog";
import { EmailCustomizationTypes } from "./EmailCustomization.types";
import CustomizeEmailLogoDialog from "./customizeEmailLogoDialog/CustomizeEmailLogoDialog.tsx";
import TablePagePaper from "@common/components/tablePagePaper/TablePagePaper";

function EmailCustomization() {
    const { translateString } = useTranslation();

    const { showUploadLogoDialog, setShowUploadLogoDialog, getBreadCrumbs, getEmailCustomizationTypesArray } = useEmailCustomization();
    const [selectedEmailType, setSelectedEmailType] = useState<EmailCustomizationTypes | null>(null);
    const handleUploadLogoClick = () => {
        setShowUploadLogoDialog(true);
    };

    const handleCloseDialog = () => {
        setShowUploadLogoDialog(false);
    };

    const handleCloseEmailTextDialog = () => {
        setSelectedEmailType(null);
    };

    function getHeaders() {
        let headers: Array<ITableHeader<IdNamePair>> = [{ property: "name", text: translateString("email"), align: "left" }];
        return headers;
    }

    const getMenuItems = (row: IdNamePair) => {
        let menuItems = [];

        menuItems.push({
            menuItem: translateString("addEmailText"),
            onClick: () => {
                setSelectedEmailType(parseInt(row.id) as EmailCustomizationTypes);
            },
        });

        return menuItems;
    };

    return (
        <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
            <DotLegalPageHeader
                breadCrumbs={getBreadCrumbs()}
                rightComponent={
                    <DotLegalButton buttonType="primary" size="medium" onClick={handleUploadLogoClick}>
                        {translateString("addLogoToMails")}
                    </DotLegalButton>
                }
            />

            <TablePagePaper>
                <DotLegalTable
                    internalScroll
                    hasOverflowMenu
                    headers={getHeaders()}
                    defaultOrderBy={"name"}
                    data={getEmailCustomizationTypesArray()}
                    paginationLabelOf={translateString("labelOf")}
                    renderRow={(row, i) => {
                        return (
                            <TableRow key={row.id} onClick={() => setSelectedEmailType(parseInt(row.id) as EmailCustomizationTypes)}>
                                <TableCell>{row.name}</TableCell>
                                <TableCell align={"right"}>
                                    <DotLegalOverflowMenu items={getMenuItems(row)} />
                                </TableCell>
                            </TableRow>
                        );
                    }}
                />
            </TablePagePaper>

            {showUploadLogoDialog && <CustomizeEmailLogoDialog onDialogClose={handleCloseDialog} />}
            {selectedEmailType !== null && <CustomizeEmailTextDialog emailType={selectedEmailType} onDialogClose={handleCloseEmailTextDialog} />}
        </Box>
    );
}

export default EmailCustomization;
